import axios, { AxiosResponse } from 'axios'
import { ClearanceDto, CredentialDto } from '../../../auth'

const API_URL = process.env.REACT_APP_API_URL
export const SIGN_URL = `${API_URL}/sign`

/**
 * Verifica crendencial para assinatura
 * @returns boolean
 */
export const checkCredential = (): Promise<boolean> => {
  return axios
    .get(`${SIGN_URL}/credential`)
    .then((response: AxiosResponse<{ message: string }>) => response.data.message === 'true')
}

/**
 * Verifica crendencial para assinatura
 * @returns ClearanceDto[]
 */
export const getClearances = (): Promise<ClearanceDto[]> => {
  return axios
    .get(`${SIGN_URL}/clearance`)
    .then((response: AxiosResponse<ClearanceDto[]>) => response.data)
}

/**
 * Autoriza credencial para assinatura
 * @param credential CredentialDto
 * @returns
 */
export const sendCredential = (credential: CredentialDto): Promise<{ message: string }> => {
  return axios
    .post(`${SIGN_URL}/credential`, credential)
    .then((response: AxiosResponse<{ message: string }>) => response.data)
}
